/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".may-have-robot-switch[_ngcontent-%COMP%]{margin-bottom:1em;padding:0 5px}.mat-dialog-content[_ngcontent-%COMP%]{min-height:140px}"];
export { styles as styles };
